import { TableCell, Typography } from "@mui/material"

const TableHeaderRowMonitoring = ({ title }) =>
  <TableCell align="left">
    <Typography variant='subtitle_bold'>{title}</Typography>
  </TableCell>

export default TableHeaderRowMonitoring